import { PalmettoTakeover, TakeoverProps } from '@palmetto/dsm-components';
import React, { useEffect, useState } from 'react';

import { useAppContainerRef } from '../../hooks/useAppContainerRef';
import useComponentTracking from '../../hooks/useComponentTracking';
import { trackEvent } from '../../tracking/Tracking';
import { useTakeoverConfig } from './TakeoverConfigProvider';

export interface TakeoverComponentProps extends TakeoverProps {
  trackingId: string;
}

export const Takeover: React.FC<TakeoverComponentProps> = (props: TakeoverComponentProps) => {
  const { children, isOpen, onClose, trackingId, theme, ...restProps } = props;
  const { suppressOpen } = useTakeoverConfig();

  const [internalOpen, setInternalOpen] = useState(false);

  const appContainerRef = useAppContainerRef();

  useEffect(() => {
    if (!isOpen || suppressOpen) {
      setInternalOpen(false);
      return;
    }
    setInternalOpen(true);
  }, [isOpen, suppressOpen]);

  const handleClose = () => {
    trackEvent('takeover closed', { trackingId });
    setInternalOpen(false);
    onClose?.();
  };

  useComponentTracking(trackingId, !internalOpen, undefined);

  if (!appContainerRef.current) {
    return null;
  }

  return (
    <PalmettoTakeover
      isOpen={internalOpen}
      onClose={handleClose}
      container={appContainerRef}
      className="p-[env(safe-area-inset-top)_env(safe-area-inset-right)_env(safe-area-inset-bottom)_env(safe-area-inset-left)]"
      theme={theme}
      {...restProps}
    >
      {children}
    </PalmettoTakeover>
  );
};
